import React, { Component } from 'react';

var BlockStatus = React.createClass({
  handlerChangeStatus: function(data){
    this.props.actionChange(data);
  },
  handlerChangeStatusFalse: function(){
    this.handlerChangeStatus(2);
  },
  handlerChangeStatusTrue: function(){
    this.handlerChangeStatus(1);
  },
  handlerChangeStatusWork: function(){
    this.handlerChangeStatus(3);
  },
  handlerChangeStatusDismiss: function(){
    this.handlerChangeStatus(4);
  },
  handlerChangeStatusNull: function(){
    this.handlerChangeStatus(0);
  },
  handlerRetrySendToServer: function(){
    this.handlerChangeStatus(5);
  },
  render: function(){
    var status1C = this.props.status1C;
    if(status1C){
      if(status1C == '0'){
        return(
          <div className="blockField dismiss SelectSpecialtiesOpen top">
            <div className="uniteField" onClick={this.handlerChangeStatusDismiss}>Отказать</div>
          </div>
        )
      }
      if(status1C == '3'){
        return(
          <div className="blockField SelectSpecialtiesOpen top">
            <div className="uniteField" onClick={this.handlerRetrySendToServer}>Отправить в 1С повторно</div>
          </div>
        )
      }
      return null;
    }else if(this.props.resStatus1C && this.props.resStatus1C != '200'){
      return(
        <div className="blockField SelectSpecialtiesOpen top">
          <div className="uniteField" onClick={this.handlerRetrySendToServer}>Отправить в 1С повторно</div>
        </div>
      )
    }
    var status = this.props.status;
    if(status === 0 || status === null){
      return(
        <div className="blockField SelectSpecialtiesOpen top">
          <div className="nameField false" onClick={this.handlerChangeStatusFalse}>Отказать</div>
          <div className="dataField true" onClick={this.handlerChangeStatusTrue}>Принять</div>
        </div>
      )
    }else if(status === 1 || status === true){
      return(
        <div className="blockField SelectSpecialtiesOpen top">
          <div className="nameField false" onClick={this.handlerChangeStatusFalse}>Отказать</div>
          <div className="dataField work" onClick={this.handlerChangeStatusWork}>Работатать</div>
        </div>
      )
    }else if(status === 2 || status === false){
      return(
        <div className="blockField true SelectSpecialtiesOpen top">
          <div className="uniteField" onClick={this.handlerChangeStatusTrue}>Принять</div>
        </div>
      )
    }else if(status === 3){
      return(
        <div className="blockField dismiss SelectSpecialtiesOpen top">
          <div className="uniteField" onClick={this.handlerChangeStatusDismiss}>Уволить</div>
        </div>
      )
    }else if(status === 4){
      return(
        <div className="blockField SelectSpecialtiesOpen top">
          <div className="uniteField" onClick={this.handlerChangeStatusNull}>Пригласить на собеседование</div>
        </div>
      )
    }else if(status === 5){
      return(
        <div className="blockField SelectSpecialtiesOpen top">
          <div className="uniteField" onClick={this.handlerRetrySendToServer}>Отправить в 1С повторно</div>
        </div>
      )
    }


  }
});

export default BlockStatus;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Profile/components/BlockStatus/index.jsx
 **/